import React from 'react';
import { Check, Crown } from 'lucide-react';
export function Upsell() {
  const features = ['Fórmula de pricing para Argentina', 'Modelo de suscripción mensual', 'Scripts para subir precios sin miedo', 'Sistema de 3 posteos semanales', 'Scripts de WhatsApp para cerrar alumnos', 'Protocolo anti clase gratis', 'Sistema de cobro sin morosidad', 'Protocolos para lumbar, rodilla y hombro', 'Adaptaciones para embarazo y adultos mayores', 'Calculadora de rentabilidad', 'Plan de acción de 90 días'];
  return <section className="py-16 md:py-24 px-4 bg-surface/40 border-y border-zinc-800/60" data-id="element-438">
      <div className="max-w-5xl mx-auto" data-id="element-439">
        <div className="text-center mb-10 md:mb-14" data-id="element-440">
          <p className="text-primary font-bold uppercase tracking-widest text-[11px] md:text-sm mb-3 flex items-center justify-center gap-2" data-id="element-441">
            <Crown className="w-4 h-4" data-id="element-442" /> Upgrade premium
          </p>
          <h2 className="text-2xl md:text-4xl font-extrabold mb-6 leading-tight max-w-3xl mx-auto" data-id="element-443">
            ¿Qué agrega el{' '}
            <span className="text-primary" data-id="element-444">Método Profe Empresario?</span>
          </h2>
          <p className="text-base md:text-lg text-zinc-300 leading-relaxed max-w-3xl mx-auto" data-id="element-445">
            No es solo dar mejores clases. Es{' '}
            <span className="text-white font-bold" data-id="element-446">
              dejar de regalar tu trabajo
            </span>{' '}
            y empezar a construir un{' '}
            <span className="text-white font-bold" data-id="element-447">negocio sólido.</span>
          </p>
        </div>

        <div className="bg-surface border border-primary/30 rounded-3xl p-6 md:p-10 shadow-[0_0_40px_rgba(74,222,128,0.08)] mb-8" data-id="element-448">
          <div className="grid md:grid-cols-2 gap-3 md:gap-4" data-id="element-449">
            {features.map((f, i) => <div key={i} className="flex items-start gap-3 bg-black/30 border border-zinc-800/60 rounded-xl p-3 md:p-4" data-id="element-450">
                <div className="bg-primary/20 p-1.5 rounded-full shrink-0 mt-0.5" data-id="element-451">
                  <Check className="w-3.5 h-3.5 text-primary" data-id="element-452" />
                </div>
                <span className="text-zinc-200 text-sm md:text-base leading-tight" data-id="element-453">
                  {f}
                </span>
              </div>)}
          </div>
        </div>

        <p className="text-center text-base md:text-xl text-zinc-200 leading-relaxed max-w-2xl mx-auto" data-id="element-454">
          Si además de dar mejores clases querés{' '}
          <span className="text-primary font-bold" data-id="element-455">ganar mejor,</span> esta es
          tu opción.
        </p>
      </div>
    </section>;
}